import { EnvironmentProviders, Provider, Type } from '@angular/core';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { customBearerTokenInterceptor } from 'keycloak-angular';
import { AbstractSolHttpMock, SOL_HTTP_MOCKS } from '../mocks/sol-http-mock';
import { provideSolHttpMockInterceptor } from '../mocks/sol-http-mock.interceptor';

export interface ProvideSolHttpClientOptions {
  mocks?: (Type<AbstractSolHttpMock<unknown>> | AbstractSolHttpMock<unknown>)[];
  /** Set to false when the app does not call `provideSolAuthentication`, as the bearer interceptor requires Keycloak. */
  authentication?: boolean;
}

export function provideSolHttpClient(options?: ProvideSolHttpClientOptions): (EnvironmentProviders | Provider)[] {
  const mocks = options?.mocks ?? [];
  const authentication = options?.authentication ?? true;
  const providers: (EnvironmentProviders | Provider)[] = [
    provideHttpClient(
      withInterceptorsFromDi(),
      ...(authentication ? [withInterceptors([customBearerTokenInterceptor])] : []),
    ),
  ];

  if (mocks.length > 0) {
    providers.push({
      provide: SOL_HTTP_MOCKS,
      useFactory: () => mocks,
    });
    providers.push(provideSolHttpMockInterceptor());
  }

  return providers;
}
